var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("transition-group", { attrs: { name: "slide-fade" } }, [
          _c(
            "div",
            {
              key: "mustHaveKeySubAbrangencia",
              class: {
                note: _vm.isFilterNotSelected,
                "note-danger": _vm.isFilterNotSelected,
              },
            },
            [
              _vm.isFiltroTipoPagarOuReceber()
                ? _c(
                    "a",
                    {
                      key: "pagaReceber1",
                      staticClass: "btn",
                      class: _vm.getClass("titulo"),
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function ($event) {
                          return _vm.filterSelected("titulo")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-pencil" }),
                      _vm._v(" Título\n                "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isFiltroTipoPagarOuReceber()
                ? _c(
                    "a",
                    {
                      key: "pagaReceber2",
                      staticClass: "btn",
                      class: _vm.getClass("devolucoes"),
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function ($event) {
                          return _vm.filterSelected("devolucoes")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-truck" }),
                      _vm._v(" Devoluções\n                "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isFiltroTipoPagarOuReceber()
                ? _c(
                    "a",
                    {
                      key: "pagaReceber3",
                      staticClass: "btn",
                      class: _vm.getClass("adiantamentos"),
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function ($event) {
                          return _vm.filterSelected("adiantamentos")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-calendar-check-o" }),
                      _vm._v(" Adiantamentos\n                "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isTesourariaEnabled()
                ? _c(
                    "a",
                    {
                      key: "pagaReceber4",
                      staticClass: "btn",
                      class: _vm.getClass("tesourariaAVista"),
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function ($event) {
                          return _vm.filterSelected("tesourariaAVista")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-scissors" }),
                      _vm._v(" Tesouraria à vista\n                "),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }